import React from 'react';
import { pdf } from '@react-pdf/renderer';
import PrescriptionPDF from '../pdf/PrescriptionPDF';

export async function createPrescriptionBlob(prescription) {
  if (!prescription) throw new Error('Prescription data is required for PDF');
  const organization = prescription?.organization || null;
  const clinic = prescription?.clinic || prescription?.patient?.registeredClinic || null;
  const instance = pdf(
    <PrescriptionPDF
      prescription={prescription}
      organization={organization}
      clinic={clinic}
    />
  );
  const blob = await instance.toBlob();
  return blob;
}

export async function downloadPrescriptionPDF(prescription) {
  try {
    const blob = await createPrescriptionBlob(prescription);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const fileName = `Prescription_${prescription.prescriptionNumber || 'RX'}_${(prescription.patient?.name || 'Patient').replace(/\s+/g,'_')}.pdf`;
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Prescription PDF download error:', err);
    throw new Error(err?.message || 'Failed to generate prescription PDF');
  }
}

export async function openPrescriptionPDF(prescription) {
  try {
    const blob = await createPrescriptionBlob(prescription);
    const url = URL.createObjectURL(blob);
    const w = window.open(url, '_blank');
    if (!w) throw new Error('Popup blocked. Allow popups for this site to print.');
  } catch (err) {
    console.error('Prescription PDF open error:', err);
    throw new Error(err?.message || 'Failed to generate prescription PDF');
  }
}
